import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=0dfbb024&"
import script from "./FilterTags.vue?vue&type=script&lang=js&"
export * from "./FilterTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports